import { confirmationRdvMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [confirmationRdvMock];

export const tunnelConfirmationMock: SlugPage = {
  ...pageBase({
    title: 'Tunnel RDV - Confirmation',
    type: 'tunnel',
    language: 'fr-FR',
    headerId: '',
    footerId: '',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
